import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import escapeRegExp from "lodash/escapeRegExp";
import { Box } from "../../../../../Box/index.js";
import { Checkbox } from "../../../../../Checkbox/index.js";
import { Badge } from "../../../../common/index.js";
import { Typography } from "../../../../../Typography/index.js";
import SelectInput_styles from "../../../SelectInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Option_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Option_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const Option = (t0)=>{
    var _option_badge;
    const $ = c(87);
    const { value, inputValue, renderOption, optionProps, option } = t0;
    const { classes } = SelectInput_styles();
    if (renderOption) {
        const t1 = option.value;
        let t2;
        if ($[0] !== option || $[1] !== renderOption) {
            t2 = renderOption(option);
            $[0] = option;
            $[1] = renderOption;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== option.value || $[4] !== optionProps || $[5] !== t2) {
            t3 = /*#__PURE__*/ createElement("li", _object_spread_props(_object_spread({}, optionProps), {
                key: t1
            }), t2);
            $[3] = option.value;
            $[4] = optionProps;
            $[5] = t2;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    const isBottom = (null == (_option_badge = option.badge) ? void 0 : _option_badge.position) === "bottom";
    const t1 = option.label;
    let T0;
    let T1;
    let T2;
    let T3;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== classes.defaultOption || $[8] !== classes.menuItem || $[9] !== classes.multiple || $[10] !== classes.option || $[11] !== inputValue || $[12] !== isBottom || $[13] !== option.badge || $[14] !== option.disabled || $[15] !== option.label || $[16] !== option.value || $[17] !== optionProps || $[18] !== value) {
        let t19;
        if ($[40] !== inputValue) {
            t19 = escapeRegExp(inputValue);
            $[40] = inputValue;
            $[41] = t19;
        } else t19 = $[41];
        const words = t1.split(new RegExp(`(${t19})`, "gi"));
        t16 = optionProps;
        t17 = option.value;
        const t20 = !option.badge;
        if ($[42] !== classes.defaultOption || $[43] !== classes.menuItem || $[44] !== classes.multiple || $[45] !== classes.option || $[46] !== t20) {
            t18 = classnames(classes.option, classes.menuItem, classes.multiple, {
                [classes.defaultOption]: t20
            });
            $[42] = classes.defaultOption;
            $[43] = classes.menuItem;
            $[44] = classes.multiple;
            $[45] = classes.option;
            $[46] = t20;
            $[47] = t18;
        } else t18 = $[47];
        T3 = Box;
        t13 = "flex";
        t14 = "center";
        let t21;
        if ($[48] !== option.value || $[49] !== value) {
            var _ref;
            t21 = null != (_ref = null == value ? void 0 : value.includes(option.value)) ? _ref : false;
            $[48] = option.value;
            $[49] = value;
            $[50] = t21;
        } else t21 = $[50];
        if ($[51] !== t21) {
            t15 = /*#__PURE__*/ jsx(Checkbox, {
                checked: t21
            });
            $[51] = t21;
            $[52] = t15;
        } else t15 = $[52];
        T2 = Box;
        t7 = "flex";
        t8 = isBottom ? "start" : "center";
        t9 = isBottom ? "column" : "row";
        t10 = "8";
        t11 = option.disabled ? "none" : "auto";
        if ($[53] !== isBottom || $[54] !== option.badge) {
            t12 = option.badge && /*#__PURE__*/ jsx(Box, {
                order: isBottom ? 1 : 0,
                children: /*#__PURE__*/ jsx(Badge, {
                    title: option.badge.title,
                    description: option.badge.description,
                    color: option.badge.color
                })
            });
            $[53] = isBottom;
            $[54] = option.badge;
            $[55] = t12;
        } else t12 = $[55];
        T1 = Box;
        t6 = isBottom ? 0 : 1;
        T0 = Typography;
        t2 = "span";
        t3 = "body3";
        t4 = inputValue ? "text.light.tertirary" : "text.light.primary";
        t5 = inputValue && words.map((part, i)=>/*#__PURE__*/ jsx(Typography, {
                component: "span",
                variant: "body3",
                color: part.toLowerCase() === inputValue.toLowerCase() ? "text.light.primary" : "text.light.tertirary",
                children: part
            }, i));
        $[7] = classes.defaultOption;
        $[8] = classes.menuItem;
        $[9] = classes.multiple;
        $[10] = classes.option;
        $[11] = inputValue;
        $[12] = isBottom;
        $[13] = option.badge;
        $[14] = option.disabled;
        $[15] = option.label;
        $[16] = option.value;
        $[17] = optionProps;
        $[18] = value;
        $[19] = T0;
        $[20] = T1;
        $[21] = T2;
        $[22] = T3;
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
        $[29] = t16;
        $[30] = t17;
        $[31] = t18;
        $[32] = t2;
        $[33] = t3;
        $[34] = t4;
        $[35] = t5;
        $[36] = t6;
        $[37] = t7;
        $[38] = t8;
        $[39] = t9;
    } else {
        T0 = $[19];
        T1 = $[20];
        T2 = $[21];
        T3 = $[22];
        t10 = $[23];
        t11 = $[24];
        t12 = $[25];
        t13 = $[26];
        t14 = $[27];
        t15 = $[28];
        t16 = $[29];
        t17 = $[30];
        t18 = $[31];
        t2 = $[32];
        t3 = $[33];
        t4 = $[34];
        t5 = $[35];
        t6 = $[36];
        t7 = $[37];
        t8 = $[38];
        t9 = $[39];
    }
    const t19 = !inputValue && option.label;
    let t20;
    if ($[56] !== T0 || $[57] !== t19 || $[58] !== t2 || $[59] !== t3 || $[60] !== t4 || $[61] !== t5) {
        t20 = /*#__PURE__*/ jsxs(T0, {
            component: t2,
            variant: t3,
            color: t4,
            children: [
                t5,
                t19
            ]
        });
        $[56] = T0;
        $[57] = t19;
        $[58] = t2;
        $[59] = t3;
        $[60] = t4;
        $[61] = t5;
        $[62] = t20;
    } else t20 = $[62];
    let t21;
    if ($[63] !== T1 || $[64] !== t20 || $[65] !== t6) {
        t21 = /*#__PURE__*/ jsx(T1, {
            order: t6,
            children: t20
        });
        $[63] = T1;
        $[64] = t20;
        $[65] = t6;
        $[66] = t21;
    } else t21 = $[66];
    let t22;
    if ($[67] !== T2 || $[68] !== t10 || $[69] !== t11 || $[70] !== t12 || $[71] !== t21 || $[72] !== t7 || $[73] !== t8 || $[74] !== t9) {
        t22 = /*#__PURE__*/ jsxs(T2, {
            display: t7,
            alignItems: t8,
            flexDirection: t9,
            gap: t10,
            pointerEvents: t11,
            children: [
                t12,
                t21
            ]
        });
        $[67] = T2;
        $[68] = t10;
        $[69] = t11;
        $[70] = t12;
        $[71] = t21;
        $[72] = t7;
        $[73] = t8;
        $[74] = t9;
        $[75] = t22;
    } else t22 = $[75];
    let t23;
    if ($[76] !== T3 || $[77] !== t13 || $[78] !== t14 || $[79] !== t15 || $[80] !== t22) {
        t23 = /*#__PURE__*/ jsxs(T3, {
            display: t13,
            alignItems: t14,
            children: [
                t15,
                t22
            ]
        });
        $[76] = T3;
        $[77] = t13;
        $[78] = t14;
        $[79] = t15;
        $[80] = t22;
        $[81] = t23;
    } else t23 = $[81];
    let t24;
    if ($[82] !== t16 || $[83] !== t17 || $[84] !== t18 || $[85] !== t23) {
        t24 = /*#__PURE__*/ createElement("li", _object_spread_props(_object_spread({}, t16), {
            key: t17,
            className: t18
        }), t23);
        $[82] = t16;
        $[83] = t17;
        $[84] = t18;
        $[85] = t23;
        $[86] = t24;
    } else t24 = $[86];
    return t24;
};
export { Option };
